import React from "react";
import logo from "../assets/graylogo.png";
import { FaFacebook, FaInstagram, FaYoutube, FaTwitter } from "react-icons/fa";
import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    // <footer className="bg-indigo-950 text-white py-8 font-play text-center">
    //   <div className="container mx-auto px-4">
    //     <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6 mb-6">
    //       <a href="#" className="text-white hover:text-gray-300 transition duration-500">
    //         <FaFacebook className="text-2xl" />
    //       </a>
    //       <a href="#" className="text-white hover:text-gray-300 transition duration-500">
    //         <FaInstagram className="text-2xl" />
    //       </a>
    //       <a href="#" className="text-white hover:text-gray-300 transition duration-500">
    //         <FaYoutube className="text-2xl" />
    //       </a>
    //       <a href="#" className="text-white hover:text-gray-300 transition duration-500">
    //         <FaTwitter className="text-2xl" />
    //       </a>
    //     </div>

    //     <div className="mb-6">
    //       <ul className="flex flex-col sm:flex-row justify-center items-center space-y-2 sm:space-y-0 sm:space-x-8">
    //         <li><a href="#" className="hover:text-gray-300 transition duration-500">Contact us</a></li>
    //         <li><a href="#" className="hover:text-gray-300 transition duration-500">Our Services</a></li>
    //         <li><a href="#" className="hover:text-gray-300 transition duration-500">Privacy Policy</a></li>
    //         <li><a href="#" className="hover:text-gray-300 transition duration-500">Terms & Conditions</a></li>
    //         <li><a href="#" className="hover:text-gray-300 transition duration-500">Career</a></li>
    //       </ul>
    //     </div>

    //     <div>
    //        Copyright © 2021 Inferno - All rights reserved
    //     </div>
    //   </div>
    // </footer>

    <footer className="bg-gray-500 text-white text-sm pt-12 pb-5">
    <div className="container mx-auto px-4">
      {/* Footer Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {/* About Section */}
        <div className="col-span-1">
          <img src={logo} className="h-64 mb-4" alt="Logo" />
          <p className="text-xl">
            At Axion Medical Billing Services, we transform the healthcare revenue cycle
            with unmatched precision and dedication. As leaders in the medical
            billing industry, we excel in streamlining complex processes,
            ensuring accuracy and efficiency at every step.
          </p>
        </div>
  
        {/* Others Section */}
        <div>
          <h6 className="text-white text-lg font-bold uppercase mb-4 tracking-widest">
            Others
          </h6>
          <ul className="space-y-2">
            <li>
            <NavLink
          to="/About"
          >
          About 
        </NavLink>
            </li>
            <li>
            <NavLink
          to="/Contact"
          >
          Contact Us
        </NavLink>
            </li>
            <li>
            <NavLink
          to="/Speciality"
          >
          Specialities
        </NavLink>
            </li>
            <li>
            <NavLink
          to="/Services"
          >
          Services
        </NavLink>
            </li>
           
          </ul>
        </div>
  
        {/* Services Section */}
        <div>
          <h6 className="text-white text-lg font-bold uppercase mb-4 tracking-widest">
            Services
          </h6>
          <ul className="space-y-2">
            <li>
            <NavLink
          to="/About"
          >
          About 
        </NavLink>
            </li>
            <li>
            <NavLink
          to="/Contact"
          >
          Contact Us
        </NavLink>
            </li>
           
          </ul>
        </div>
  
        {/* Additional Section: Resources */}
        <div>
          <h6 className="text-white text-lg font-bold uppercase mb-4 tracking-widest">
            Contact US
          </h6>
          <ul className="space-y-2">
            <li>
            <a
  href="https://www.google.com/maps/search/?api=1&query=3466+Crayrich+Dr,+Birmingham,+AL+35226"
  target="_blank"
  rel="noopener noreferrer"
  className="hover:text-blue-500"
>
  3466 Crayrich Dr, Birmingham, AL 35226
</a>

            </li>
            <li>
            <a
  href="https://mail.google.com/mail/?view=cm&fs=1&to=info@axionmbs.com"
  target="_blank"
  rel="noopener noreferrer"
  className="hover:text-blue-500"
>
  info@axionmbs.com
</a>

            </li>
            <li>
            <a
  href="tel:+18884871178"
  className="hover:text-blue-500"
>
  (111) 111-1111
</a>

            </li>
          </ul>
        </div>
      </div>
  
      <hr className="border-gray-600 my-6" />
  
      {/* Footer Bottom */}
      <div className="flex flex-wrap justify-between items-center text-center md:text-left">
        <p className="text-gray-400 mb-4 md:mb-0">
          © 2024 All Rights Reserved by{" "}
          <a href="#" className="text-blue-500 hover:text-blue-400">
            Axion MBS
          </a>
          .
        </p>
  
        {/* Social Icons */}
        <ul className="flex space-x-4">
          <li>
            <a
              href="#"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-700 hover:bg-blue-600"
            >
              <i className="fa fa-facebook text-white"></i>
            </a>
          </li>
          <li>
            <a
              href="#"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-700 hover:bg-blue-400"
            >
              <i className="fa fa-twitter text-white"></i>
            </a>
          </li>
          <li>
            <a
              href="#"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-700 hover:bg-pink-500"
            >
              <i className="fa fa-dribbble text-white"></i>
            </a>
          </li>
          <li>
            <a
              href="#"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-700 hover:bg-blue-700"
            >
              <i className="fa fa-linkedin text-white"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
  
  );
};

export default Footer;
